import Axios from 'axios'
import React, { Component } from 'react'
import { connect } from 'react-redux'
import Loader from 'shared/components/Loader.jsx'
import withVerifyCheck from 'shared/providers/withVerifyCheck.jsx';

import {beginSignIn as beginSignInAction} from 'actions/creators/Auth';
import { getLanguageType } from '../../../constants/Language'

class Cybersport extends Component {
  state = {
    isLoading: false,
    token: null,
  }

  componentDidMount = () => {
    this.fetchToken()
    this.hideJivo()
  }

  componentDidUpdate = (prevProps) => {
    if (prevProps.locale !== this.props.locale || prevProps.gamblerId !== this.props.gamblerId) {
      this.fetchToken()
    }
    if (prevProps.gamblerId !== this.props.gamblerId && !this.props.gamblerId) {
      this.props.beginSignInAction()
      this.props.router.push('/')
    }
  }

  componentWillUnmount = () => {
    this.unHideJivo()
  }

  hideJivo = () => {
    try {
      const styles = `
        jdiv { 
          display: none!important;
        }
      `
      const styleSheet = document.createElement('style')
      styleSheet.id = 'jdiv-id-key'
      styleSheet.innerText = styles
      document.head.appendChild(styleSheet)
    } catch (err) {
      console.log(err)
    }
  }

  unHideJivo = () => {
    try {
      document.getElementById('jdiv-id-key').remove()
    } catch (err) {
      console.log(err)
    }
  }

  fetchToken = async () => {
    try {
      this.setState({ isLoading: true })
      const { data = {} } = await Axios({
        url: '/api/games-databet/',
      })
      if (data.token) {
        this.setState({
          token: data.token,
        })
      }
    } catch (error) {
      console.error(error)
    }

    this.setState({ isLoading: false })
  }

  render() {
    const { isLoading, token } = this.state
    const { locale, isVerified } = this.props

    let urlLocale = locale === 'kk' ? 'ru' : locale

    if (isLoading) return <Loader />

    return (
      <iframe
        style={{
          position: 'fixed',
          top: 75,
          left: 8,
          right: 8,
          bottom: 8,
          width: 'calc(100vw - 16px)',
          height: 'calc(100vh - 83px)',
        }}
        // scrolling="no"
        frameBorder="0"
        sandbox="allow-scripts allow-same-origin"
        allowFullScreen
        src={`/databet.html?locale=${urlLocale || ''}&token=${token || ''}`}
      />
    )
  }
}

export default withVerifyCheck(connect((s) => {
  const languageId = s.application.get('languageId')
  const gamblerId = s.auth.get('user') && s.auth.get('user').get('gamblerId')

  return {
    locale: getLanguageType(languageId).name,
    gamblerId,
  }
}, { beginSignInAction })(Cybersport))



// WEBPACK FOOTER //
// ./js/sport-betting/components/pages/Cybersport.jsx